// Modules
import { NgModule } from '@angular/core';
import {
    MatToolbarModule, MatButtonModule, MatIconModule, MatInputModule,
    MatSidenavModule, MatListModule, MatDialogModule, MatSnackBarModule,
    MatTableModule, MatPaginatorModule, MatSortModule, MatCardModule,
    MatSlideToggleModule, MatSelectModule, MatDatepickerModule, MatNativeDateModule,
    MatRadioModule, MatCheckboxModule
} from '@angular/material';
import { DragDropModule } from '@angular/cdk/drag-drop';

const matModules = [
    MatToolbarModule, MatButtonModule, MatIconModule, MatInputModule,
    MatSidenavModule, MatListModule, MatDialogModule, MatSnackBarModule,
    MatTableModule, MatPaginatorModule, MatSortModule, MatCardModule,
    MatSlideToggleModule, DragDropModule, MatSelectModule, MatDatepickerModule,
    MatNativeDateModule, MatRadioModule, MatCheckboxModule
];

@NgModule({
    imports: matModules,
    exports: matModules
})

export class MaterialModule {}